import axios from 'axios';
import { generatePath } from 'react-router-dom';

import { DISTANCE_RACERS_URL } from 'src/constants';

import { action, request } from 'utils';

import { LOAD_RACERS } from '../constants';

import { RacersStore } from '../stores';

class Racers {
  @request({ action: LOAD_RACERS })
  request(distanceId: number, params: FiltersType): Promise<any> {
    const url = generatePath(DISTANCE_RACERS_URL, { distanceId });
    return axios.get(url, { params });
  }

  @action({ action: LOAD_RACERS })
  async load(distanceId: number): Promise<RacerType[]> {
    const params = RacersStore.defaultFilters;
    const [status, response] = await this.request(distanceId, params);

    if (!status) {
      return [];
    }

    return response.data.data;
  }
}

export { Racers, Racers as RacersService };
